import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4";


//check if it is production
const isProduction = process.env.NODE_ENV === 'production';

if(isProduction){
// Initialize Google tracking
ReactGA.initialize(process.env.REACT_APP_GA4_TRACKING);

}

const root = ReactDOM.createRoot(document.getElementById('nizu'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
